import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import AbilityProvider from '../../../permissionsUtils/AbilityProvider';
import { PERMISSIONS, PERMISSION_ENTITIES } from '../../../_config/consts.js';
import CustomField from '../Fields/CustomField.jsx';
import CustomTableFields from '../../CustomTables/CustomTableFields.jsx';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'required';
  } else if (_.trim(values.name).length > 255) {
    errors.name = 'maximumLenghtTwelve';
  }
  if (!values.description) {
    errors.description = 'required';
  }
  return errors;
};

@reduxForm({ form: 'CustomTableForm', validate })
@connect(state => ({}))
class CustomTableForm extends React.Component {
  render() {
    const canCreateCustomTable = true //AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.ALL], PERMISSION_ENTITIES.CUSTOM_TABLE);
    
    return (
      <Form>
        <input style={{ display: 'none' }} type="username" name="username" />
        <FormFlatContainer title="tableData" containerStyle={{ marginTop: 0 }}>
          <Entity
            componentClass={Field}
            name="name"
            componentAttribute="placeholder"
            entity="insertTableName"
            title={<Entity entity="tableName" />}
            component={CustomField}
            type="text"
            disabled={!canCreateCustomTable}
            mandatory
          />
          {/* Table Description */}
          <Entity
            componentClass={Field}
            name="description"
            componentAttribute="placeholder"
            entity="insertTableDescription"
            title={<Entity entity="tableDescription" />}
            component={CustomField}
            type="textarea"
            className="form-control-custom"
            disabled={!canCreateCustomTable}
          />
        </FormFlatContainer>
        {/* <FormFlatContainer title="tableFields">
          <CustomTableFields
            onAddField={(field) => onAddTableField(field)}
            onEditField={(field) => onEditTableField(field)}
            onDeleteField={(field) => onDeleteTableField(field)}
          />
        </FormFlatContainer> */}
      </Form>
    );
  }
}

export default CustomTableForm; 